import React from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';

import MudarSenha from '~/components/AlterarSenha';
import { Container, Background, Logo } from '../styles';

function AlterarSenha() {
	const { token } = useParams();

	return (
		<Container>
			<Background />
			<div className="d-flex justify-content-center w-100">
				<Card className="p-5">
					<CardBody>
						<div className="mb-4">
							<Logo />
						</div>
						<MudarSenha reset tokenUrl={token} />
					</CardBody>
				</Card>
			</div>
		</Container>
	);
}

export default AlterarSenha;
